<template>
  <div class="date-picker mr-2">
    <v-menu
      v-model="date_menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y

      max-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="filterDate"
          :label="dateFilter.title"
          prepend-icon="event"
          readonly
          v-on="on"
          clearable
          hide-details
        ></v-text-field>
      </template>
      <v-card tile class="mx-auto">
        <v-list v-for="(option, index) in options" :key="index">
          <v-list-item @click="setDate(option)">
            <v-list-item-content>
              <v-list-item-title>{{$t('general.'+option)}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <input type="text" id="date-picker" style="max-height: 0px">
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import 'lightpick/css/lightpick.css'
import Lightpick from 'lightpick'
// import router from '@/router'

export default {
  name: 'AlgoliaDateFilter',
  props: {
    dateFilter: Object,
    index: Number,
    inSeconds: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      picker: '',
      startDate: null,
      endDate: null,
      date_menu: false,
      options: ['today', 'tomorrow', 'thisWeek', 'thisMonth', 'custom']
    }
  },
  computed: {
    ...mapState(['generalApp']),
    filter () {
      if (this.startDate && this.endDate) {
        let start = this.removeTime(this.startDate) // set time of date to 00:00:00 and convert to miliseconds
        let end = (this.removeTime(this.endDate) + 86399) // set time for whole end day (00:00:00 - 23:59:59) , 86399 seconds == 23:59:59 hours and convert to miliseconds
        if (!this.inSeconds) {
          start *= 1000
          end *= 1000
        }
        return this.dateFilter.attribute + ':' + start + ' TO ' + end
      } else {
        return ''
      }
    },
    filterDate: {
      get () {
        if (this.startDate && this.endDate) {
          const readableStart = this.$options.filters.unixDateToReadableShort(this.startDate, this.$i18n.locale)
          const readableEnd = this.$options.filters.unixDateToReadableShort(this.endDate, this.$i18n.locale)
          if (readableStart === readableEnd) {
            return readableStart
          } else {
            return readableStart + ' - ' + readableEnd
          }
        } else {
          return ''
        }
      },
      set (newValue) {
        // date input field was cleared
        if (newValue === null) {
          this.startDate = null
          this.endDate = null
        }
      }
    }
  },
  methods: {
    ...mapActions({
      setDateFilter: 'setDateFilter',
      clearDateFilter: 'clearDateFilter'
    }),
    setDate (option) {
      let start = null
      let end = null
      switch (option) {
        case 'today':
          start = new Date()
          end = new Date()
          break
        case 'tomorrow':
          let today = new Date()
          let tomorrow = new Date()
          tomorrow.setDate(today.getDate() + 1)
          start = tomorrow
          end = tomorrow
          break
        case 'thisWeek':
          var curr = new Date()
          start = new Date(curr.setDate(curr.getDate() - curr.getDay() + 1))
          end = new Date(curr.setDate(curr.getDate() - curr.getDay() + 7))
          break
        case 'thisMonth':
          let date = new Date(); let y = date.getFullYear(); let m = date.getMonth()
          start = new Date(y, m, 1)
          end = new Date(y, m + 1, 0)
          break
        case 'custom':
          if (this.startDate && this.endDate) {
            this.picker.setDateRange(new Date(this.startDate * 1000), new Date(this.endDate * 1000))
          }
          this.picker.show()
          break
        default:
      }
      this.startDate = start / 1000 | 0
      this.endDate = end / 1000 | 0
      this.date_menu = false
    },
    removeTime (timestamp) {
      let withoutTime = new Date(timestamp * 1000)
      withoutTime.setHours(0, 0, 0, 0)
      withoutTime = withoutTime / 1000 | 0
      return withoutTime
    }
  },
  watch: {
    picker: {
      deep: true,
      handler (value) {
        this.startDate = this.picker.getStartDate() / 1000 | 0
        this.endDate = this.picker.getEndDate() / 1000 | 0
      }
    },
    filter () {
      this.setDateFilter({ filter: this.filter, index: this.index })
    },
    'generalApp.algoliaDateFilters': {
      deep: true,
      handler (value) {
        if (value[this.index] === undefined) {
          this.startDate = null
          this.endDate = null
        } else {
          const dates = value[this.index].split(':')[1].split(' TO ')
          if (this.inSeconds) {
            this.startDate = dates[0]
            this.endDate = dates[1]
          } else {
            this.startDate = dates[0] / 1000 | 0
            this.endDate = dates[1] / 1000 | 0
          }
        }
      }
    }
  },
  created () {
    this.clearDateFilter()
  },
  mounted () {
    // date picker initialization
    this.picker = new Lightpick({
      field: document.getElementById('date-picker'),
      singleDate: false
    })
    this.picker.hide()
  }
}
</script>
